import React from "react";
import { Row, Col, Tooltip } from "antd";
import Highlighter from "react-highlight-words"
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import TransactionDetailsTable from "./../Components/TransactionDetailsTable/TransactionDetailsTable.js";
import { TableData } from "./../Components/TransactionDetailsTable/styles";
import {
  ColumnHeader,
  ImgRec
} from "./../Components/BalanceDetailsTable/styles.js";
import recurringIcon from "./../../../assets/icons/recurring-icon.svg";
import grantIcon from "./../../../assets/icons/grant-agreement.svg";
import TitleNode from "./../Components/CardComponent/TitleNode.js";
import CardComponent from "./../Components/CardComponent/CardComponent.js";
import { DataVal, TxnVal } from "./../Components/CardComponent/styles.js";
import { selectHeader } from "../../../actions/globalActions";
import history from "./../../../history/history";
import formatter from './../../../utils/formatter';
import { milliToDate, checkIEBrowser, recordError } from './../../../utils/commonUtil';
import PurposeSummary from "./../../Grants/Components/PurposeSummary/PurposeSummary";
import { sortAsNegativeSymbol } from './../../../utils/sorter';
import { renderDate } from "../Pages/txnUitls";
import queryString from "query-string";

export const renderAmount = (text, data, searchText) => {
  if (text && text !== "-") {
    let amount = formatter({
      value: text,
      fieldSuffix: 'Dollars',
    })
    if (data.reversal) {
      return (
        <TableData>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={amount}>
            {amount}
          </Highlighter>
        </TableData>
      )
    } else {
      return (
        <TableData>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={`(${amount})`}>
            {amount}
          </Highlighter>
        </TableData>
      )
    }
  } else {
    return (
      <TableData>
        {text === 0 ? '$0.00' : '-'}
      </TableData>);
  }
}

export const renderText = (text, searchText) => {
  if (text) {
    return (
      <TableData break ie={checkIEBrowser()}>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text}>
          {text}
        </Highlighter>
      </TableData>)
  } else {
    return (<TableData>-</TableData>)
  }
}

export const renderPurpose = (text, row, searchText) => {
  if (text) {
    return (
      <Tooltip
        placement="bottom"
        title={<PurposeSummary {...row.purpose} />}
      >
        <TxnVal>
          <TableData break ie={checkIEBrowser()}>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={row.purpose.description}>
              {row.purpose.description}
            </Highlighter>
          </TableData>
        </TxnVal>
      </Tooltip>
    )
  } else {
    return (<TableData>-</TableData>)
  }
}

export const renderRecur = (recur, data) => {
  if (recur) {
    return (
      <TableData>
        <ImgRec><img src={recurringIcon} alt="Recurring" /></ImgRec>
      </TableData>
    )
  }
  if (data.grantAgreementPayement) {
    return (
      <TableData>
        <img src={grantIcon} alt="Recurring" />
      </TableData>
    )
  }
}

export const renderTxnView = function (txnId, data, searchText) {
  if (txnId) {
    return (
      <TxnVal isDisabled={data.reversal || data.grantAgreementPayement} onClick={!data.reversal && !data.grantAgreementPayement ? () => viewGrants(txnId, data) : null}>
        <TableData break ie={checkIEBrowser()}>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={txnId}>
            {txnId}
          </Highlighter>
        </TableData>
      </TxnVal>
    )
  } else {
    return (<TableData>-</TableData>)
  }
}

export const renderTxnViewMob = function (txnId, data, searchText) {
  if (txnId) {
    return (
      <>
        <TxnVal isDisabled={data.reversal || data.grantAgreementPayement} onClick={!data.reversal && !data.grantAgreementPayement ? () => viewGrants(txnId, data) : null}>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={txnId}>
            {txnId}
          </Highlighter>
        </TxnVal>
      </>
    )
  } else {
    return (<TableData>-</TableData>)
  }
}

export const viewGrants = (id, data) => {
  try {
    let checkClearedDate = data.checkClearedDate;
    history.push({
      pathname: "/grants/activity/view",
      search: queryString.stringify({ grantId: id }),
      state: { checkClearedDate }
    });
  } catch (error) {
    recordError(error);
  }
};

export const renderTitleGrid = (pool, searchText) => {
  return (
    <>
      <TitleNode title="Entered Date" />
      <DataVal>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={milliToDate(pool)}>
          {milliToDate(pool)}
        </Highlighter>
      </DataVal>
    </>
  );
};

export const renderFixGrid = ({ each, gridName, type, star }, searchText) => {
  switch (type) {
    case 'date':
      let dateVal = milliToDate(each[gridName]);
      if (star) {
        dateVal = `${milliToDate(each[gridName])}*`;
      }

      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName])
              ?
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={dateVal}>
                  {dateVal}
                </Highlighter>
              </DataVal>
              : '-'
          }
        </>
      )
    case 'amount':
      let dollarsAmount = formatter({
        value: each[gridName],
        fieldSuffix: 'Dollars',
      });
      return (
        <>
          <TitleNode title="Dollar amount" />
          {
            (each[gridName])
              ?
              <DataVal>
                {
                  (each.reversal)

                    ?
                    <Highlighter
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={dollarsAmount}>
                      {dollarsAmount}
                    </Highlighter>
                    :
                    <Highlighter
                      highlightStyle={{
                        color: "black",
                        fontWeight: 600,
                        backgroundColor: "transparent"
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={`${dollarsAmount}`}>
                      {dollarsAmount}
                    </Highlighter>
                }

              </DataVal>
              : (each[gridName] === 0) ? '$0.00' : '-'
          }
        </>
      )
    case 'number':
      let value = each[gridName] + '';
      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName])
              ?
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={value}>
                  {value}
                </Highlighter>
              </DataVal>
              : '-'
          }
        </>
      )
    case 'purpose':
      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName])
              ?
              <DataVal>
                {
                  <Tooltip
                    placement="bottom"
                    title={<PurposeSummary {...each.purpose} />}
                    trigger="click"
                  >
                    <TxnVal>
                      <Highlighter
                        highlightStyle={{
                          color: "black",
                          fontWeight: 600,
                          backgroundColor: "transparent"
                        }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={each.purpose.description}>
                        {each.purpose.description}
                      </Highlighter>
                    </TxnVal>
                  </Tooltip>
                }
              </DataVal>
              : '-'
          }
        </>
      );
      break;
    default:
      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName])
              ?
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={each[gridName]}>
                  {each[gridName]}
                </Highlighter>
              </DataVal>
              : '-'
          }
        </>
      );
  }
};

export const renderRecurring = (data) => {
  if (data.recurring) {
    return (
      <img src={recurringIcon} alt="Recurring" />
    )
  }
  if (data.grantAgreementPayement) {
    return (
      <img src={grantIcon} alt="Grant Payment" />
    )
  }
}

export const GrantsTable = ({ searchText, grantsData }) => {

  const columns = [
    {
      title: <ColumnHeader>Transaction ID</ColumnHeader>,
      render: (txnId, data) => renderTxnView(txnId, data, searchText),
      dataIndex: "transactionId",
      key: "transactionId",
      width: 80,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.transactionId.localeCompare(b.transactionId) }
    },
    {
      title: <ColumnHeader>Entered Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "enteredDate",
      key: "enteredDate",
      width: 80,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.enteredDate - b.enteredDate }
    },
    {
      title: <ColumnHeader>Charity Name</ColumnHeader>,
      render: (text) => renderText(text, searchText),
      dataIndex: "charityName",
      key: "charityName",
      width: 80,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.charityName.localeCompare(b.charityName) }
    },
    {
      title: <ColumnHeader>Interest Area</ColumnHeader>,
      render: (text) => renderText(text, searchText),
      dataIndex: "interestArea",
      key: "interestArea",
      width: 80,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.interestArea.localeCompare(b.interestArea) }
    },
    {
      title: <ColumnHeader>Amount</ColumnHeader>,
      render: (text, data) => renderAmount(text, data, searchText),
      dataIndex: "amount",
      key: "amount",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => {
        return sortAsNegativeSymbol(a.amount, b.amount, a.reversal, b.reversal);
      }
    },
    {
      title: <ColumnHeader>Purpose</ColumnHeader>,
      render: (text, row) => renderPurpose(text, row, searchText),
      dataIndex: "purpose",
      key: "purpose",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.purpose.description.localeCompare(b.purpose.description) }
    },
    {
      title: <ColumnHeader>Trade Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "tradeDate",
      key: "tradeDate",
      width: 80,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.tradeDate - b.tradeDate }
    },
    {
      title: null,
      render: renderRecur,
      dataIndex: "recurring",
      key: "recurring",
      width: 80,
    }
  ];

  const destObj = (each) => {
    return [
      {
        name: "transactionId",
        type: "FixGrid",
        gridWidth: "50",
        render: renderTxnViewMob(each['transactionId'], each, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "enteredDate",
        gridWidth: "100",
        type: "FixGrid",
        render: renderTitleGrid(each.enteredDate, searchText),
        ptop: true,
        pbottom: true,
        pright: true
      },
      {
        name: "charityName",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "charityName" }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "interestArea",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "interestArea" }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "amount",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "amount", type: 'amount' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "purpose",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "purpose", type: 'purpose' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "tradeDate",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "tradeDate", type: 'date' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "recur",
        type: "FixGrid",
        gridWidth: "50",
        render: renderRecurring(each),
        ptop: true,
        pbottom: true,
        pleft: true
      }
    ];
  };
  
  return (
    <Row id="table-search-grants" data-test="transaction-grant-table">
      <Col lg={24} md={0} xs={0}>
        <TransactionDetailsTable data-test="transaction-grant-table-desktop" className="transGrantsTab" tabIdentifier="Grants" tabName="grants" scroll={{ y: 500 }} columns={columns} data={grantsData} searchText={searchText} />
      </Col>
      <Col lg={0} md={24} xs={24} className="mobCard">
        <CardComponent data-test="transaction-grant-table-mobile" tabName="grants" destObj={destObj} data={grantsData} searchText={searchText} />
      </Col>
    </Row>
  );
};

GrantsTable.propTypes = {
  searchText: PropTypes.string,
  grantsData: PropTypes.arrayOf(PropTypes.object)
}

const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
  };
};

export default connect(null, mapDispatchToProps)(GrantsTable);
